export default __webpack_public_path__ + "static/media/circle_2.7656d74e.svg";